import React from 'react';
import '../../styles/kyro-design.css';

const GrievanceRedressal: React.FC = () => {
  return (
    <div className="page">
      <div className="login-hero-min">
        <div className="hero-grid" />
        <div className="hero-glow" />
        <div className="hero-inner" style={{ textAlign: 'center', maxWidth: 'none' }}>
          <h1 style={{ fontSize: 'clamp(1.8rem, 3vw, 2.4rem)' }}>Grievance Redressal Policy</h1>
          <p className="hero-sub" style={{ margin: '0.5rem 0 0', opacity: 0.7 }}>Prepared: July 09, 2026</p>
        </div>
      </div>

      <div className="legal-content-min">
            <div style={{ background: 'var(--off)', padding: '1rem', border: '1px solid var(--gray-lt)', marginBottom: '1.5rem' }}>
              <p><strong>Fund:</strong> Kyro India Opportunities Fund – I</p>
              <p><strong>Trust:</strong> Kyro Alternative Investment Trust</p>
              <p><strong>Prepared:</strong> July 09, 2026</p>
              <p><strong>Reviewed:</strong> –</p>
              <a
                className="btn-p"
                href="/assets/policies/kyro-grievance-redressal-policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginTop: '0.4rem' }}
              >
                View / Download PDF ↓
              </a>
            </div>

            <div>
              <h2>A. Background</h2>
              <p>
                The Securities and Exchange Board of India (“SEBI”) vide SEBI (Alternative Investment Funds)
                Regulations, 2012 (“AIF Regulations”) and the following circulars, has mandated Investment Manager
                to address all investor grievances and prescribes an intermediary (including AIF), by itself or
                through the investment manager or sponsor, to lay down the procedure for resolution of disputes
                between the investors, AIF, Investment Manager or Sponsor through arbitration or any such mechanism
                as mutually decided between the investors and the AIF.
              </p>
              <ul>
                <li>SEBI Circular No. CIR/MIRSD/3/2014 dated August 28, 2014 on Information regarding Grievance Redressal Mechanism.</li>
                <li>SEBI Master Circular No. HO/19/34/11(6)2025-AFD-POD1/I/12928/2026 dated June 03, 2026 for Alternative Investment Funds (AIFs).</li>
                <li>SEBI Master Circular No. SEBI/HO/OIAE/OIAE_IAD-3/P/CIR/2023/195 dated December 28, 2023 for Online Resolution of Disputes in the Indian Securities Market.</li>
                <li>SEBI Circular No. SEBI/HO/OIAE/IGRD/CIR/P/2023/156 dated September 20, 2023 on Redressal of investor grievances through the SEBI Complaint Redressal (SCORES) Platform and linking it to Online Dispute Resolution platform.</li>
              </ul>
            </div>

            <div>
              <h2>B. Purpose</h2>
              <p>
                Kyro Asset Management Private Limited (“Investment Manager”) is acting as the investment manager to
                Kyro Alternative Investment Trust (“Trust”), organised in India and registered with SEBI as a
                Category II Alternative Investment Fund, and various schemes launched under the Trust from time to
                time including its first scheme – Kyro India Opportunities Fund – I.
              </p>
              <p>
                Investment Manager believes that investor service is a vital element for sustained business growth
                and wants to ensure that the investors receive exemplary service. Prompt and efficient service is
                essential to retaining existing relationships and therefore investor satisfaction becomes critical
                to Investment Manager. Investor queries and complaints constitute an important voice of investor,
                and this policy details grievance handling through a structured grievance redressal framework.
                Grievance redressal is supported by a review mechanism, to minimize the recurrence of similar
                issues in future.
              </p>
              <p>
                In compliance with the aforesaid requirements, Investment Manager has framed the Investor Grievance
                Redressal Policy (the “Policy”) to lay down the grievance redressal framework and the dispute
                resolution mechanism it will follow in the event an investor raises a grievance with respect to the
                activities of the fund. The Policy will be read in accordance with the provisions of the
                Contribution Agreements (as entered and will be entered from time to time and to the extent relevant
                in the current context) and the latter will prevail in case of any differences.
              </p>
            </div>

            <div>
              <h2>C. Objective</h2>
              <ol>
                <li>To ensure that all the investors are treated fairly at all times;</li>
                <li>To deal with all the complaints raised by the investors in a timely manner;</li>
                <li>To make the investors aware about all the avenues of grievance redressal available to them for the resolution of their complaint(s);</li>
                <li>To warrant that all the queries and complaints are treated efficiently and fairly.</li>
              </ol>
            </div>

            <div>
              <h2>D. Scope</h2>
              <p>
                A grievance is defined under this Policy as a written or verbal expression of dissatisfaction against
                the operation of the fund or Investment Manager and its employees resulting from a potential damage
                or wrongdoing to an investor or from a violation of SEBI guidelines or related laws/regulations which
                may or may not request for a claim for compensation.
              </p>
              <p>
                Grievances will include allegations such as failure to disclose conflicts of interest,
                misrepresentations, etc. Such grievances may be regarding processing of drawdown transactions,
                distribution of units etc. Investor feedbacks, queries or clarifications will not be considered as
                instances of complaint or grievance.
              </p>
              <p>
                Such grievances if not addressed in due course will hamper the fund’s reputation and functioning.
                Hence, this Policy provides for the framework to be adopted by Investment Manager with respect to
                effective redressal, in the event of any investor grievance.
              </p>
            </div>

            <div>
              <h2>E. Grievance Redressal Framework</h2>

              <h3>Registration of investor’s grievance with Investment Manager</h3>
              <p>
                Investors can seek clarifications to their query and are further entitled to make a complaint in
                writing, orally or telephonically. Any grievances received from the investors will be directed and
                acknowledged by the Compliance Officer of the fund. Investment Manager shall address such grievance
                promptly within a time period of 21 (twenty-one) calendar days from the date of receipt of the
                grievance.
              </p>
              <p>
                <strong>Contact Centre:</strong> Investors can contact the Compliance Officer named in the Private
                Placement Memorandum of the respective fund.
              </p>
              <p>
                <strong>Letter:</strong> Investors can write to Investment Manager with their query or complaint at
                the below given address:
              </p>
              <div style={{ background: 'var(--off)', padding: '1rem', border: '1px solid var(--gray-lt)', margin: '1rem 0' }}>
                <p style={{ marginBottom: 0 }}>
                  303, Unity One, Survey No. 180-1 and 181-1, Pipalia Rao, Rajiv Gandhi Square,
                  Indore, Madhya Pradesh – 452001
                </p>
              </div>

              <h3>Registration of investor’s grievance on the SEBI Complaints Redress System (SCORES) website</h3>
              <p>
                Without prejudice to anything stated above, any investor may further register their grievance/
                complaint through SCORES (SEBI Complaints Redress System) available at{' '}
                <a href="https://scores.sebi.gov.in" target="_blank" rel="noopener noreferrer">scores.sebi.gov.in</a>,
                post which SEBI may forward the complaint to Investment Manager and Investment Manager will suitably
                address the same.
              </p>
              <p>
                Upon receiving complaints through the SCORES platform, Investment Manager will ensure its resolution
                within 21 (twenty-one) calendar days from date of receipt of such complaint. During such period, the
                investor will be kept duly informed of the status and actions taken.
              </p>
              <p>
                Investors may also send their complaints to: Office of Investor Assistance and Education, Securities
                and Exchange Board of India, SEBI Bhavan, Plot No. C4-A, ‘G’ Block, Bandra-Kurla Complex, Bandra (E),
                Mumbai – 400051.
              </p>

              <h3>Dispute resolution mechanism</h3>
              <p>
                Any dispute unresolved by the above internal grievance redressal mechanism of Investment Manager, may
                be submitted to arbitration under the Arbitration and Conciliation Act, 1996. The arbitration shall be
                held in accordance with the terms of the Contribution Agreement. The dispute resolution mechanism
                between Investment Manager and/ or the trustee and the investors of the fund will be as specified in
                the relevant fund documents and will be complied with at all times. The investor may register itself
                on the SMART ODR portal{' '}
                <a href="https://smartodr.in/" target="_blank" rel="noopener noreferrer">smartodr.in</a> for online
                dispute resolution.
              </p>

              <h3>Internal mechanism for handling Queries/ Complaints</h3>
              <p><strong>a) Resolution of Grievances</strong></p>
              <p>
                Investment Manager after receiving the complaint is responsible for ensuring that the query /
                complaint is resolved to the investor’s satisfaction and must attempt to offer the investor alternate
                solutions, however if the investor remains unsatisfied with the resolution, he can escalate the issue
                through the grievance redressal mechanism.
              </p>
              <p><strong>b) Timeline for handling the queries</strong></p>
              <p>
                Queries/ complaints are investigated within the stipulated timelines for handling queries/ complaints
                received at the different levels of escalation. Certain types of queries/ complaints, involving fraud,
                legal inputs and third party (other banks/ aggregator), needing more time for investigation, are
                acknowledged accordingly and the turnaround time is communicated to the investors.
              </p>
              <p><strong>c) Staff training on handling complaints</strong></p>
              <p>
                The Compliance Officer and their team are specially trained for handling queries/ complaints. Training
                includes both operations and soft skills, as different investors perceive and react differently to the
                aspects of complaint handling. The staff is encouraged to have an open attitude towards service
                recovery and winning the investor’s confidence.
              </p>
            </div>

            <div>
              <h2>F. Disclosure of Queries/ Complaints</h2>
              <p>
                Queries/ complaints with the resolution time will be uploaded on the website or intimated via email on
                a monthly basis, for information of investors.
              </p>
              <p>
                For effective monitoring, Investment Manager will also maintain data on investor complaints as per
                prescribed format, which shall be compiled latest within 7 (seven) days from the end of quarter.
              </p>
            </div>

            <div>
              <h2>G. Maintenance of Records</h2>
              <p>
                All documents relating to investors grievances and resolutions, including escalated matters will be
                maintained for records. Investment Manager will submit periodic reports to SEBI/ the trustee on the
                complaints received, status and steps taken to address the same.
              </p>
              <p>
                The same shall also be updated in respective Private Placement Memorandum (PPM), etc. as may be
                required under AIF Regulations, as amended from time to time.
              </p>
            </div>

            <div>
              <h2>H. Review of Complaint</h2>
              <ul>
                <li>
                  The Compliance Officer shall regularly monitor and review complaints according to its nature,
                  originating branch, against a particular employee and/or sub-brokers, authorized person etc. and on
                  the basis of such analysis, inform the management to take adequate steps to strengthen the systems.
                </li>
                <li>Investment Manager shall review the status of the pending complaints.</li>
              </ul>
            </div>

            <div>
              <h2>I. Review of the Policy</h2>
              <p>
                The Policy will be reviewed as and when warranted due to the changes in the regulatory framework,
                business or operational reasons and best practices as may be deemed appropriate.
              </p>
            </div>

            <div>
              <h2>J. Contact</h2>
              <p>To raise a grievance or for any related queries, please contact:</p>
              <div style={{ background: 'var(--off)', padding: '1rem', border: '1px solid var(--gray-lt)', marginTop: '1rem' }}>
                <p><strong>Kyro Asset Management Private Limited</strong></p>
                <p>Email: <a href="mailto:compliance@kyrocapital.in">compliance@kyrocapital.in</a></p>
                <p>Phone: +91 76 111 111 02</p>
                <p style={{ marginBottom: 0 }}>
                  Address: 303, Unity One, Survey No. 180-1 and 181-1, Pipalia Rao, Rajiv Gandhi Square,
                  Indore, Madhya Pradesh – 452001
                </p>
              </div>
            </div>
          </div>
    </div>
  );
};

export default GrievanceRedressal;
